export const LOAD_TEMPLATE_BEGIN = 'LOAD_TEMPLATE_BEGIN';
export const LOAD_TEMPLATE_SUCCESS = 'LOAD_TEMPLATE_SUCCESS';
export const LOAD_TEMPLATE_FAILURE = 'LOAD_TEMPLATE_FAILURE';

export const FETCH_TEMPLATES_SUCCESS = 'FETCH_TEMPLATES_SUCCESS';
export const FETCH_TEMPLATES_BEGIN = 'FETCH_TEMPLATES_BEGIN';
export const FETCH_TEMPLATES_FAILURE = 'FETCH_TEMPLATES_FAILURE';

export const INCREMENT_STEP = 'INCREMENT_STEP';
export const RENDER_PAGE2_EVENT_CREATION = 'RENDER_PAGE2_EVENT_CREATION';

export const HANDLE_EVENT_START_DATE_SAVE = 'HANDLE_EVENT_START_DATE_SAVE';
export const HANDLE_EVENT_END_DATE_SAVE = 'HANDLE_EVENT_END_DATE_SAVE';
export const HANDLE_FLASH_DATE_SAVE = 'HANDLE_FLASH_DATE_SAVE';
export const HANDLE_STANDARD_DELIVERY_DATE_SAVE =
  'HANDLE_STANDARD_DELIVERY_DATE_SAVE';
export const HANDLE_ANNOUNCEMENT_DATE_SAVE = 'HANDLE_ANNOUNCEMENT_DATE_SAVE';
export const HANDLE_DOORS_DATE_SAVE = 'HANDLE_DOORS_DATE_SAVE';
export const HANDLE_ETICKET_DATE_SAVE = 'HANDLE_ETICKET_DATE_SAVE';
export const HANDLE_ON_SALE_DATE_SAVE = 'HANDLE_ON_SALE_DATE_SAVE';
export const HANDLE_EXPIRATION_DATE_SAVE = 'HANDLE_EXPIRATION_DATE_SAVE';
export const HANDLE_EXPIRATION_DATE_RESET = 'HANDLE_EXPIRATION_DATE_RESET';
export const HANDLE_EVENT_NAME_INPUT = 'HANDLE_EVENT_NAME_INPUT';
export const HANDLE_EVENT_LOOKUP_ID_INPUT = 'HANDLE_EVENT_LOOKUP_ID_INPUT';
export const HANDLE_PRICE_LEVEL_OVERRIDE_IN_MANIFEST =
  'HANDLE_PRICE_LEVEL_OVERRIDE_IN_MANIFEST';

export const FETCH_VENUE_MAPS_BEGIN = 'FETCH_VENUE_MAPS_BEGIN';
export const FETCH_VENUE_MAPS_SUCCESS = 'FETCH_VENUE_MAPS_SUCCESS';
export const FETCH_VENUE_MAPS_FAILURE = 'FETCH_VENUE_MAPS_FAILURE';

export const HANDLE_SELECT_VENUE_MAP_FROM_DROPDOWN =
  'HANDLE_SELECT_VENUE_MAP_FROM_DROPDOWN';
export const STORE_EVENT_LOOKUP_ID = 'STORE_EVENT_LOOKUP_ID';

export const HANDLE_CMS_AGE_CHANGE = 'HANDLE_CMS_AGE_CHANGE';
export const HANDLE_CMS_STATUS_CHANGE = 'HANDLE_CMS_STATUS_CHANGE';
export const HANDLE_CMS_MAJOR_CATEGORY_CHANGE =
  'HANDLE_CMS_MAJOR_CATEGORY_CHANGE';
export const HANDLE_CMS_MINOR_CATEGORY_CHANGE =
  'HANDLE_CMS_MINOR_CATEGORY_CHANGE';
export const HANDLE_CMS_PUBLISH_STATUS_CHANGE =
  'HANDLE_CMS_PUBLISH_STATUS_CHANGE';
export const HANDLE_CMS_EDP_STATUS_CHANGE = 'HANDLE_CMS_EDP_STATUS_CHANGE';
export const HANDLE_CMS_BIO_CHANGE = 'HANDLE_CMS_BIO_CHANGE';
export const HANDLE_CMS_DESCRIPTION_CHANGE = 'HANDLE_CMS_DESCRIPTION_CHANGE';

export const HANDLE_SITE_VISIBILITY = 'HANDLE_SITE_VISIBILITY';
export const HANDLE_PRESENTED_BY = 'HANDLE_PRESENTED_BY';
export const HANDLE_TOUR = 'HANDLE_TOUR';
export const HANDLE_DOOR_PRICE = 'HANDLE_DOOR_PRICE';
export const HANDLE_TICKET_PRICE = 'HANDLE_TICKET_PRICE';

export const LOAD_CREATE_EVENT_DETAILS_BEGIN =
  'LOAD_CREATE_EVENT_DETAILS_BEGIN';
export const LOAD_CREATE_EVENT_DETAILS_SUCCESS =
  'LOAD_CREATE_EVENT_DETAILS_SUCCESS';
export const LOAD_CREATE_EVENT_DETAILS_FAILURE =
  'LOAD_CREATE_EVENT_DETAILS_FAILURE';

export const EVENT_LOOKUPID_CHECK_BEGIN = 'EVENT_LOOKUPID_CHECK_BEGIN';
export const EVENT_LOOKUPID_CHECK_FAILURE = 'EVENT_LOOKUPID_CHECK_FAILURE';
export const EVENT_LOOKUPID_CHECK_SUCCESS = 'EVENT_LOOKUPID_CHECK_SUCCESS';

export const PUBLISH_EVENT_BEGIN = 'PUBLISH_EVENT_BEGIN';
export const PUBLISH_EVENT_SUCCESS = 'PUBLISH_EVENT_SUCCESS';
export const PUBLISH_EVENT_FAILURE = 'PUBLISH_EVENT_FAILURE';

export const PUBLISH_PORTAL_EVENT_BEGIN = 'PUBLISH_PORTAL_EVENT_BEGIN';
export const PUBLISH_PORTAL_EVENT_SUCCESS = 'PUBLISH_PORTAL_EVENT_SUCCESS';
export const PUBLISH_PORTAL_EVENT_FAILURE = 'PUBLISH_PORTAL_EVENT_FAILURE';

export const UPDATE_EVENT_BEGIN = 'UPDATE_EVENT_BEGIN';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_FAILURE = 'UPDATE_EVENT_FAILURE';
export const RESET_EVENT = 'RESET_EVENT';

export const CREATE_CMS_EVENT_BEGIN = 'CREATE_CMS_EVENT_BEGIN';
export const CREATE_CMS_EVENT_SUCCESS = 'CREATE_CMS_EVENT_SUCCESS';
export const CREATE_CMS_EVENT_FAILURE = 'CREATE_CMS_EVENT_FAILURE';

export const DIRECT_TO_EVENT_DETAILS = 'DIRECT_TO_EVENT_DETAILS';
export const DIRECT_TO_CREATE_EDIT_EVENT = 'DIRECT_TO_CREATE_EDIT_EVENT';
export const CREATE_INITIAL_TIME_VALUES = 'CREATE_INITIAL_TIME_VALUES';

export const SAVE_ORIGINAL_TEMPLATE_ID_BEGIN =
  'SAVE_ORIGINAL_TEMPLATE_ID_BEGIN';
export const SAVE_ORIGINAL_TEMPLATE_ID_SUCCESS =
  'SAVE_ORIGINAL_TEMPLATE_ID_SUCCESS';
export const SAVE_ORIGINAL_TEMPLATE_ID_FAILURE =
  'SAVE_ORIGINAL_TEMPLATE_ID_FAILURE';

export const HANDLE_ORIGINAL_TEMPLATE_ID = 'HANDLE_ORIGINAL_TEMPLATE_ID';

export const CHECK_FOR_EVENT_OVERLAP_BEGIN = 'CHECK_FOR_EVENT_OVERLAP_BEGIN';
export const CHECK_FOR_EVENT_OVERLAP_SUCCESS =
  'CHECK_FOR_EVENT_OVERLAP_SUCCESS';
export const CHECK_FOR_EVENT_OVERLAP_FAILURE =
  'CHECK_FOR_EVENT_OVERLAP_FAILURE';

export const SEARCH_PROMOTERS_BEGIN = 'SEARCH_PROMOTER_BEGIN';
export const SEARCH_PROMOTERS_SUCCESS = 'SEARCH_PROMOTER_SUCCESS';
export const SEARCH_PROMOTERS_FAILURE = 'SEARCH_PROMOTER_FAILURE';

export const ADD_HEADLINER = 'ADD_HEADLINER';
export const ADD_SUPPORTING_ACT = 'ADD_SUPPORTING_ACT';
export const ADD_PROMOTER = 'ADD_PROMOTER';

export const REMOVE_HEADLINER = 'REMOVE_HEADLINER';
export const REMOVE_SUPPORTING_ACT = 'REMOVE_SUPPORTING_ACT';
export const REMOVE_PROMOTER = 'REMOVE_PROMOTER';

export const LOAD_EVENT_DETAILS = 'LOAD_EVENT_DETAILS';
export const LOAD_EVENT_DETAILS_BEGIN = 'LOAD_EVENT_DETAILS_BEGIN';
export const LOAD_EVENT_DETAILS_SUCCESS = 'LOAD_EVENT_DETAILS_SUCCESS';
export const LOAD_EVENT_DETAILS_FAILURE = 'LOAD_EVENT_DETAILS_FAILURE';
export const LOAD_EVENT_DETAILS_ABORT = 'LOAD_EVENT_DETAILS_ABORT';

export const LOAD_PORTAL_EVENT_DETAILS = 'LOAD_PORTAL_EVENT_DETAILS';
export const DIRECT_TO_EVENT = 'DIRECT_TO_EVENT';

export const DIRECT_TO_OFFERS = 'DIRECT_TO_OFFERS';
export const DIRECT_TO_OFFER_SETTINGS = 'DIRECT_TO_OFFER_SETTINGS';
export const DIRECT_TO_EDIT_OFFER = 'DIRECT_TO_EDIT_OFFER';
export const DIRECT_TO_ADD_OFFERS = 'DIRECT_TO_ADD_OFFERS';

export const REDIRECT_TO_EVENTS = 'REDIRECT_TO_EVENTS';
export const CANCEL_ZONE_SETTINGS = 'CANCEL_ZONE_SETTINGS';
export const CANCEL_ADMISSIONS = 'CANCEL_ADMISSIONS';
export const TOGGLE_ACCESS_CONTROL = 'TOGGLE_ACCESS_CONTROL';
export const REDIRECT_TO_PATH = 'REDIRECT_TO_PATH';
export const RETRIEVE_ALL_OFFERS_BEGIN = 'RETRIEVE_ALL_OFFERS_BEGIN';
export const GET_OFFER_BY_ID = 'GET_OFFER_BY_ID';
export const GET_OFFER_BY_ID_BEGIN = 'GET_OFFER_BY_ID_BEGIN';
export const GET_OFFER_BY_ID_SUCCESS = 'GET_OFFER_BY_ID_SUCCESS';
export const GET_OFFER_BY_ID_FAILURE = 'GET_OFFER_BY_ID_FAILURE';
export const RETRIEVE_ALL_OFFERS_SUCCESS = 'RETRIEVE_ALL_OFFERS_SUCCESS';
export const GET_OFFER = 'GET_OFFER';
export const UPDATE_OFFER = 'UPDATE_OFFER';

export const SAVE_ZONE_SETTINGS = 'SAVE_ZONE_SETTINGS';
export const SAVE_ZONE_BEGIN = 'SAVE_ZONE_BEGIN';
export const SAVE_ZONE_SUCCESS = 'SAVE_ZONE_SUCCESS';
export const SAVE_ZONE_FAILURE = 'SAVE_ZONE_FAILURE';

export const SAVE_FLASHSEAT_BEGIN = 'SAVE_FLASHSEAT_BEGIN';
export const SAVE_FLASHSEAT_SUCCESS = 'SAVE_FLASHSEAT_SUCCESS';
export const SAVE_FLASHSEAT_FAILURE = 'SAVE_FLASHSEAT_FAILURE';
export const CANCEL_FLASHSEAT_SETTINGS = 'CANCEL_FLASHSEAT_SETTINGS';

export const SET_ONSALE_DATE = 'SET_ONSALE_DATE';
export const SET_GENERAL_ONSALE_DATE = 'SET_GENERAL_ONSALE_DATE';

export const LOAD_TEMPLATE_BASE_EVENT_DATA_BEGIN =
  'LOAD_TEMPLATE_BASE_EVENT_DATA_BEGIN';
export const LOAD_TEMPLATE_BASE_EVENT_DATA_SUCCESS =
  'LOAD_TEMPLATE_BASE_EVENT_DATA_SUCCESS';
export const LOAD_TEMPLATE_BASE_EVENT_DATA_FAILURE =
  'LOAD_TEMPLATE_BASE_EVENT_DATA_FAILURE';

export const AUTO_PUBLISH_OFFERS_BEGIN = 'AUTO_PUBLISH_OFFERS_BEGIN';
export const AUTO_PUBLISH_OFFERS_FAILURE = 'AUTO_PUBLISH_OFFERS_FAILURE';
export const AUTO_PUBLISH_OFFERS_SUCCESS = 'AUTO_PUBLISH_OFFERS_SUCCESS';

export const LOAD_PORTAL_TEMPLATE_BASE_EVENT_DATA_BEGIN =
  'LOAD_PORTAL_TEMPLATE_BASE_EVENT_DATA_BEGIN';
export const LOAD_PORTAL_TEMPLATE_BASE_EVENT_DATA_SUCCESS =
  'LOAD_PORTAL_TEMPLATE_BASE_EVENT_DATA_SUCCESS';
export const LOAD_PORTAL_TEMPLATE_BASE_EVENT_DATA_FAILURE =
  'LOAD_PORTAL_TEMPLATE_BASE_EVENT_DATA_FAILURE';

export const LOAD_TEMPLATE_BASE_BEGIN = 'LOAD_TEMPLATE_BASE_BEGIN';
export const LOAD_TEMPLATE_BASE_SUCCESS = 'LOAD_TEMPLATE_BASE_SUCCESS';
export const LOAD_TEMPLATE_BASE_FAILURE = 'LOAD_TEMPLATE_BASE_FAILURE';

export const LOAD_PORTAL_TEMPLATE_BASE_BEGIN =
  'LOAD_PORTAL_TEMPLATE_BASE_BEGIN';
export const LOAD_PORTAL_TEMPLATE_BASE_SUCCESS =
  'LOAD_PORTAL_TEMPLATE_BASE_SUCCESS';
export const LOAD_PORTAL_TEMPLATE_BASE_FAILURE =
  'LOAD_PORTAL_TEMPLATE_BASE_FAILURE';

export const LOAD_TICKET_TEXT_TEMPLATES_BEGIN =
  'LOAD_TICKET_TEXT_TEMPLATES_BEGIN';
export const LOAD_TICKET_TEXT_TEMPLATES_SUCCESS =
  'LOAD_TICKET_TEXT_TEMPLATES_SUCCESS';
export const LOAD_TICKET_TEXT_TEMPLATES_FAILURE =
  'LOAD_TICKET_TEXT_TEMPLATES_FAILURE';

export const SET_TICKET_TEXT_TEMPLATE = 'SET_TICKET_TEXT_TEMPLATE';

export const ADD_TEMPLATE_OFFERS_TO_EDP = 'ADD_TEMPLATE_OFFERS_TO_EDP';
export const DIRECT_TO_EDP = 'DIRECT_TO_EDP';
export const FLAG_OFFER_IS_INCOMPLETE = 'FLAG_OFFER_IS_INCOMPLETE';
export const STORE_OFFER_TEMPLATE_ID = 'STORE_OFFER_TEMPLATE_ID';
export const CLEAR_EVENT = 'CLEAR_EVENT';
export const CLEAR_TEMPLATE_OFFERS = 'CLEAR_TEMPLATE_OFFERS';
export const DIRECT_TO_ADMISSIONS = 'DIRECT_TO_ADMISSIONS';
export const CLEAR_TEMPLATE_BASE_EVENT_DATA = 'CLEAR_TEMPLATE_BASE_EVENT_DATA';
export const DIRECT_TO_EVENT_INFORMATION = 'DIRECT_TO_EVENT_INFORMATION';
export const DIRECT_TO_ADD_ZONES = 'DIRECT_TO_ADD_ZONES';
export const DIRECT_TO_EDP_PORTAL_EVENT = 'DIRECT_TO_EDP_PORTAL_EVENT';
export const DIRECT_TO_OFFER_DETAILS = 'DIRECT_TO_OFFER_DETAILS';
export const RESET_OFFER_TEMPLATE_ID = 'RESET_OFFER_TEMPLATE_ID';
export const REMOVE_TEMPLATE_OFFER = 'REMOVE_TEMPLATE_OFFER';
export const UPDATE_ORIGINAL_TEMPLATE_ID = 'UPDATE_ORIGINAL_TEMPLATE_ID';
export const CLEAR_BASE_TEMPLATE = 'CLEAR_BASE_TEMPLATE';
export const GET_STATUS_CODES_BEGIN = 'GET_STATUS_CODES_BEGIN';
export const GET_STATUS_CODES_FAILURE = 'GET_STATUS_CODES_FAILURE';
export const GET_STATUS_CODES_SUCCESS = 'GET_STATUS_CODES_SUCCESS';
export const GET_PRICE_LEVELS_SUCCESS = 'GET_PRICE_LEVELS_SUCCESS';
export const HANDLE_LOOKUP_ID_INPUT = 'HANDLE_LOOKUP_ID_INPUT';
export const GET_PAYMENT_METHODS_BEGIN = 'GET_PAYMENT_METHODS_BEGIN';
export const GET_PAYMENT_METHODS_FAILURE = 'GET_PAYMENT_METHODS_FAILURE';
export const GET_PAYMENT_METHODS_SUCCESS = 'GET_PAYMENT_METHODS_SUCCESS';
export const GENERATE_NEW_OFFER_LOOKUP_ID = 'GENERATE_NEW_OFFER_LOOKUP_ID';
export const SET_LAST_SAVED_OFFER = 'SET_LAST_SAVED_OFFER';
export const SET_HAS_MODIFIED_OFFERS = 'SET_HAS_MODIFIED_OFFERS';

export const SET_IMAGE = 'SET_IMAGE';
export const SET_IMAGE_SQUARE = 'SET_IMAGE_SQUARE';
export const SET_IMAGE_FACEBOOK = 'SET_IMAGE_FACEBOOK';

export const DELETE_MEDIA = 'DELETE_MEDIA';

export const GET_SITES_BEGIN = 'GET_SITES_BEGIN';
export const GET_SITES_SUCCESS = 'GET_SITES_SUCCESS';
export const GET_SITES_FAILURE = 'GET_SITES_FAILURE';

export const SET_IS_SAVING_FLAG = 'SET_IS_SAVING_FLAG';
export const SET_IS_LOADING_FLAG = 'SET_IS_LOADING_FLAG';

export const LOAD_CMS_REVISIONS_BEGIN = 'LOAD_CMS_REVISIONS_BEGIN';
export const LOAD_CMS_REVISIONS_SUCCESS = 'LOAD_CMS_REVISIONS_SUCCESS';
export const LOAD_CMS_REVISIONS_FAILURE = 'LOAD_CMS_REVISIONS_FAILURE';

export const AUTO_COMPLETE_ARTISTS_RESPONSE = 'AUTO_COMPLETE_ARTISTS_RESPONSE';
export const SEARCH_TAGS_BEGIN = 'SEARCH_TAGS_BEGIN';
export const SEARCH_TAGS_FAILURE = 'SEARCH_TAGS_FAILURE';

export const REMOVE_TAG = 'REMOVE_TAG';
export const ADD_TAG = 'ADD_TAG';

export const REMOVE_PRICE_CODE_FROM_EVENT = 'REMOVE_PRICE_CODE_FROM_EVENT';
export const ADD_PRICE_CODES_TO_EVENT = 'ADD_PRICE_CODES_TO_EVENT';

export const HANDLE_AXS_MANAGER_CHANGE = 'HANDLE_AXS_MANAGER_CHANGE';
export const GET_AXS_MANAGER_OPTIONS_BEGIN = 'GET_AXS_MANAGER_OPTIONS_BEGIN';
export const GET_AXS_MANAGER_OPTIONS_SUCCESS =
  'GET_AXS_MANAGER_OPTIONS_SUCCESS';
export const GET_AXS_MANAGER_OPTIONS_FAILURE =
  'GET_AXS_MANAGER_OPTIONS_FAILURE';

export const HANDLE_VENUE_MANAGER_CHANGE = 'HANDLE_VENUE_MANAGER_CHANGE';
export const GET_VENUE_MANAGER_OPTIONS_BEGIN =
  'GET_VENUE_MANAGER_OPTIONS_BEGIN';
export const GET_VENUE_MANAGER_OPTIONS_SUCCESS =
  'GET_VENUE_MANAGER_OPTIONS_SUCCESS';
export const GET_VENUE_MANAGER_OPTIONS_FAILURE =
  'GET_VENUE_MANAGER_OPTIONS_FAILURE';

export const SELECT_EVENT_TYPE_FROM_DROPDOWN =
  'SELECT_EVENT_TYPE_FROM_DROPDOWN';
export const SELECT_SEASON_TYPE_FROM_DROPDOWN =
  'SELECT_SEASON_TYPE_FROM_DROPDOWN';

export const FETCH_EMAIL_TEMPLATES_SUCCESS = 'FETCH_EMAIL_TEMPLATES_SUCCESS';
export const FETCH_EMAIL_TEMPLATES_BEGIN = 'FETCH_EMAIL_TEMPLATES_BEGIN';
export const FETCH_EMAIL_TEMPLATES_FAILURE = 'FETCH_EMAIL_TEMPLATES_FAILURE';
export const HANDLE_CREATE_CMS_EVENT = 'HANDLE_CREATE_CMS_EVENT';
export const HANDLE_EVENT_TEMPLATE_CHANGE = 'HANDLE_EVENT_TEMPLATE_CHANGE';

export const FETCH_TAX_PROFILE_BEGIN = 'FETCH_TAX_PROFILE_BEGIN';
export const FETCH_TAX_PROFILE_SUCCESS = 'FETCH_TAX_PROFILE_SUCCESS';
export const FETCH_TAX_PROFILE_FAILURE = 'FETCH_TAX_PROFILE_FAILURE';
export const SET_SHORT_CODES_FLAG = 'SET_SHORT_CODES_FLAG';
export const SET_LISTING_EXPIRATION_FLAG = 'SET_LISTING_EXPIRATION_FLAG';
export const HANDLE_SHORT_CODES_CHANGE = 'HANDLE_SHORT_CODES_CHANGE';
export const FETCH_SHORT_CODES_BEGIN = 'FETCH_SHORT_CODES_BEGIN';
export const FETCH_SHORT_CODES_SUCCESS = 'FETCH_SHORT_CODES_SUCCESS';
export const FETCH_SHORT_CODES_FAILURE = 'FETCH_SHORT_CODES_FAILURE';



// WEBPACK FOOTER //
// ./src/routes/EventDetails/modules/constants.js